module.exports = __webpack_public_path__ + "img/1717485605831-WhatsApp Image 2024-06-04 at 14.06.57.jpeg.622ef1f2.webp";